/**
 * Build a file URL with a query token so <img>/<video> can fetch protected files.
 * The backend allows ?auth=<JWT> as a fallback when headers cannot be set.
 */
import { getToken } from '../api';

const BASE = process.env.REACT_APP_BACKEND_URL || '';

export const buildFileUrl = (urlOrId) => {
  if (!urlOrId) return '';
  const token = getToken();
  let path = urlOrId;
  if (!path.startsWith('/api/') && !path.startsWith('http')) {
    path = `/api/files/${urlOrId}`;
  }
  const sep = path.includes('?') ? '&' : '?';
  return `${BASE}${path}${token ? `${sep}auth=${encodeURIComponent(token)}` : ''}`;
};

export const uploadFile = async (file, purpose, axiosInstance) => {
  const form = new FormData();
  form.append('file', file);
  form.append('purpose', purpose);
  const { data } = await axiosInstance.post('/files/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};
